export default "__VITE_ASSET__CRphBG$N__"